import ChipInSuccess from './no_chip_in'
import { connect } from 'react-redux'

const mapStateToProps = (state, props) => {
  return {}
}

const mapDispatchToProps = dispatch => {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChipInSuccess)
